<template>
  <div>
    <base-title-bar-scroll-page ref="container" :back="true" :show-title-bar="showTitleBar" back-text="主页"
                                title="脊柱侧弯康复服务"
                                @onBackClick="onBackClick">

      <my-img style="width: 100%" url="https://cdn.keihong.tech/img/202412221730992.png"/>

      <!-- 脊柱侧弯专业服务套餐 -->
      <div class="service-package">
        <div class="package-title">脊柱侧弯康复服务套餐</div>

        <!-- 基础筛查服务 -->
        <div class="service-card" @click="onPayClick(1)">
          <div class="service-header">
            <h3>基础筛查评估服务</h3>
            <div class="price">¥199</div>
          </div>
          <div class="service-content">
            <ul>
              <li>专业脊柱侧弯筛查</li>
              <li>详细评估报告</li>
              <li>初步康复建议</li>
              <li>专家在线解读</li>
            </ul>
          </div>
        </div>

        <!-- 综合康复服务 -->
        <div class="service-card recommended" @click="onPayClick(2)">
          <div class="recommend-badge">推荐</div>
          <div class="service-header">
            <h3>综合康复指导服务</h3>
            <div class="price">¥699</div>
          </div>
          <div class="service-content">
            <ul>
              <li>全面脊柱功能评估</li>
              <li>个性化康复方案制定</li>
              <li>30天居家康复指导</li>
              <li>专业物理治疗师跟踪</li>
              <li>康复效果定期评估</li>
              <li>24小时在线咨询支持</li>
            </ul>
          </div>
        </div>

        <!-- VIP专享服务 -->
        <div class="service-card vip" @click="onPayClick(3)">
          <div class="vip-badge">VIP</div>
          <div class="service-header">
            <h3>VIP专享康复服务</h3>
            <div class="price">¥1299</div>
          </div>
          <div class="service-content">
            <ul>
              <li>一对一专家面诊</li>
              <li>详细影像学分析</li>
              <li>90天个性化康复方案</li>
              <li>专业矫正器械指导</li>
              <li>定期线下复查评估</li>
              <li>家庭康复环境指导</li>
              <li>营养膳食搭配建议</li>
            </ul>
          </div>
        </div>
      </div>

      <div style="text-align: center;font-size: 14px;color: #494949;margin-top: 20px;">
        技术支持：动优科技·健康顺德脊柱侧弯康复中心
      </div>
    </base-title-bar-scroll-page>

    <!-- 支付信息填写弹窗 -->
    <van-popup v-model="showInput" class="popup-wrapper" position="bottom" style="height: 60vh">
      <div class="payment-form">
        <div class="form-title">
          *您正在购买【{{ getServiceName() }}】
        </div>

        <div class="input-wrapper">
          <van-field
            v-model="patientName"
            label="患者姓名"
            placeholder="请输入患者姓名"
            required
            type="text"
          />
          <van-field
            v-model="patientMobile"
            label="联系手机"
            placeholder="请输入联系手机号"
            required
            type="tel"
          />
          <van-field
            v-model="patientAge"
            label="患者年龄"
            placeholder="请输入患者年龄"
            required
            type="number"
          />
          <van-field
            v-model="remarks"
            label="备注信息"
            placeholder="请简述脊柱侧弯情况（可选）"
            type="textarea"
            rows="3"
          />
        </div>

        <div class="button-wrapper">
          <van-button style="width: 100%;margin-bottom: 16px" type="primary" @click="submitPayment">
            立即支付 ¥{{ getTotalPrice() }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 支付成功弹窗 -->
    <van-popup v-model="showPopup" :close-on-click-overlay="false" class="popup-wrapper" position="bottom">
      <div class="success-popup">
        <img alt="Success Logo" class="success-logo" src="https://cdn.keihong.tech/img/202312211813200.png">
        <div class="success-message">支付成功</div>
        <div class="order-info">
          <div>订单编号：{{ outTradeNo }}</div>
          <div>{{ orderCreateTime }}</div>
          <div class="service-name">{{ getServiceName() }}</div>
        </div>
        <div class="next-steps">
          <h4>接下来您需要：</h4>
          <ol>
            <li>我们的专业团队将在24小时内联系您</li>
            <li>安排专业评估和制定康复方案</li>
            <li>开始您的脊柱侧弯康复之旅</li>
          </ol>
        </div>
        <van-button style="width: 100%;margin-top: 16px" type="primary" @click="refreshPage">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import { Dialog, Notify, Toast } from 'vant'
import WxPayDao from '@/h5/doucan/network/WxPayDao'
import wx from 'weixin-jsapi'
import DateUtils from '@/utils/DateUtils'
import MyImg from '@/h5/doucan/components/MyImg.vue'

export default {
  name: 'ShunyiPay',
  components: {
    MyImg,
    BaseTitleBarScrollPage
  },
  data () {
    return {
      from: '',
      showTitleBar: true,
      showPopup: false,
      showInput: false,
      hospital: {
        name: '健康顺德脊柱侧弯康复中心'
      },
      patientName: '',
      patientMobile: '',
      patientAge: '',
      remarks: '',
      userGender: '', // 用户性别
      thirdPartyUserId: '', // 第三方系统用户ID
      testMobile: ['18008000808', '13610164743', '18520535303', '18501011010'],
      openId: '',
      serviceType: null,
      outTradeNo: '',
      orderCreateTime: null,
      servicePackages: {
        1: { name: '基础筛查评估服务', price: 199 },
        2: { name: '综合康复指导服务', price: 699 },
        3: { name: 'VIP专享康复服务', price: 1299 }
      }
    }
  },
  mounted () {
    const query = this.$route.query
    this.from = query.from
    const phone = query.phone
    const name = query.name
    const openid = query.openid
    const gender = query.gender
    const userId = query.userId

    // 预填充用户信息
    if (name) {
      this.patientName = name
    }
    if (phone) {
      this.patientMobile = phone
    }

    // 存储新增参数
    this.userGender = gender || ''
    this.thirdPartyUserId = userId || ''

    console.log('支付页面参数:', {
      from: this.from,
      phone,
      name,
      gender,
      userId,
      openid
    })

    if (this.from === 'wxapp') {
      this.showTitleBar = false
      this.openId = openid
    } else {
      // 判断是否是微信浏览器
      const isWeChatBrowser = () => {
        const userAgent = navigator.userAgent.toLowerCase()
        return userAgent.includes('micromessenger')
      }

      if (isWeChatBrowser()) {
        this.initWx()
      }
    }

    this.$refs.container.stopLoading()
  },
  methods: {
    onPayClick (type) {
      this.serviceType = type
      this.showInput = true
    },
    getServiceName () {
      return this.servicePackages[this.serviceType]?.name || ''
    },
    getTotalPrice () {
      return this.servicePackages[this.serviceType]?.price || 0
    },
    onBackClick () {
      window.location.href = 'https://doucan.jianerkanggz.cn/#/Shunyi/home'
    },
    refreshPage () {
      this.showPopup = false
      if (this.from === 'wxapp') {
        // 小程序，返回到小程序首页
      } else {
        // 扫码网页版，返回到首页
        this.onBackClick()
      }
    },
    async submitPayment () {
      if (!this.patientName || !this.patientMobile || !this.patientAge) {
        Notify({
          type: 'danger',
          message: '请填写完整的患者信息'
        })
        return
      }

      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(this.patientMobile)) {
        Notify({
          type: 'danger',
          message: '请输入正确的手机号码'
        })
        return
      }

      Toast.loading({
        message: '处理中...',
        forbidClick: true
      })

      let fee = this.getTotalPrice()
      if (this.testMobile.includes(this.patientMobile)) {
        fee = 0.01
      }

      const fromActivity = '健康顺德脊柱侧弯康复服务'
      const serviceName = this.getServiceName()
      const goods = `${this.hospital.name}-${serviceName}-患者:${this.patientName}`

      const remark = `${fromActivity}-${serviceName}-${this.hospital.name}-${this.patientName}-${this.patientMobile}-年龄:${this.patientAge}-性别:${this.userGender || '未知'}-第三方ID:${this.thirdPartyUserId || '无'}-${this.remarks || '无备注'}`

      const profile = {
        serveType: 0,
        mobile: this.patientMobile,
        patientName: this.patientName,
        patientMobile: this.patientMobile,
        patientAge: this.patientAge,
        patientGender: this.userGender, // 新增性别字段
        thirdPartyUserId: this.thirdPartyUserId, // 新增第三方用户ID
        orderType: 'spine_rehabilitation',
        fee: fee,
        fromActivity: fromActivity,
        goods: goods,
        openId: this.openId,
        hospital: this.hospital.name,
        serviceType: this.serviceType,
        remark: remark
      }

      console.log('提交订单', profile)

      try {
        this.orderCreateTime = DateUtils.formateDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
        const data = await WxPayDao.createOrder(profile, this.from === 'wxapp')

        if (data.code === 1) {
          this.outTradeNo = data.data.outTradeNo
          this.showInput = false

          if (this.from === 'wxapp') {
            // 小程序支付逻辑
            const payInfo = {
              ...data.data,
              orderInfo: {
                outTradeNo: this.outTradeNo,
                orderCreateTime: this.orderCreateTime,
                remark: remark
              }
            }

            const wxJson = JSON.stringify(payInfo)
            const encodedParam = encodeURIComponent(wxJson)
            window.wx.miniProgram.navigateTo({
              url: `/pages/pay_submit_universe/pay_submit_universe?param=${encodedParam}`
            })
          } else {
            // 微信H5支付逻辑
            this.handleWechatPay(data.data)
          }
        } else {
          console.log('支付失败-订单创建失败', data)
          Toast.fail('订单创建失败，请重试')
        }
      } catch (error) {
        console.error('支付过程出错:', error)
        Toast.fail('支付过程出错，请重试')
      }
    },
    async handleWechatPay (paySignInfo) {
      wx.config({
        debug: false,
        appId: paySignInfo.sign.appId,
        timestamp: paySignInfo.sign.timeStamp,
        nonceStr: paySignInfo.sign.nonceStr,
        signature: paySignInfo.sign.paySign,
        jsApiList: ['chooseWXPay']
      })

      wx.ready(() => {
        const _that = this
        wx.chooseWXPay({
          timestamp: paySignInfo.sign.timeStamp,
          nonceStr: paySignInfo.sign.nonceStr,
          package: paySignInfo.sign.packageValue,
          signType: paySignInfo.sign.signType,
          paySign: paySignInfo.sign.paySign,
          success: function (res) {
            if (res.errMsg === 'chooseWXPay:ok') {
              console.log('支付成功', res)
              _that.showPopup = true
            } else {
              Dialog({ message: JSON.stringify(res) })
            }
          },
          fail: function (res) {
            Dialog({ message: '支付失败:' + JSON.stringify(res) })
          }
        })
      })

      wx.error((err) => {
        alert(err)
      })
    },
    async initWx () {
      // 微信授权相关逻辑
      const openid = this.$store.state.user.openId
      if (openid) {
        this.openId = openid
      } else {
        await this.getMpOpenID()
      }
    },
    async getMpOpenID () {
      // 获取微信openid的逻辑
      const code = this.getUrlKey('code')
      if (code) {
        await this.getOpenId(code)
      } else {
        this.getCodeApi()
      }
    },
    getUrlKey (name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [undefined, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    getCodeApi () {
      const appid = 'wxcb56667c309e369b'
      const urlNow = encodeURIComponent(window.location.href)
      const scope = 'snsapi_base'
      const url =
        'https://open.weixin.qq.com' +
        '/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        urlNow +
        '&response_type=code&scope=' +
        scope +
        '#wechat_redirect'
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.service-package {
  padding: 16px;
}

.package-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.service-card {
  background: white;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
}

.service-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.service-card.recommended {
  border: 2px solid #4CAF50;
}

.service-card.vip {
  border: 2px solid #FF9800;
  background: linear-gradient(135deg, #fff9e6 0%, #ffffff 100%);
}

.recommend-badge, .vip-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 12px;
  font-size: 12px;
  color: white;
  font-weight: 600;
}

.recommend-badge {
  background: #4CAF50;
}

.vip-badge {
  background: #FF9800;
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.service-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.price {
  font-size: 24px;
  font-weight: 700;
  color: #1976D2;
}

.service-content {
  padding: 16px;
}

.service-content ul {
  margin: 0;
  padding-left: 16px;
  list-style: none;
}

.service-content li {
  position: relative;
  padding: 4px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.service-content li:before {
  content: "✓";
  position: absolute;
  left: -16px;
  color: #4CAF50;
  font-weight: 600;
}

.popup-wrapper {
  border-radius: 16px 16px 0 0;
}

.payment-form {
  padding: 20px;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.input-wrapper {
  margin-bottom: 20px;
}

.button-wrapper {
  padding-top: 10px;
}

.success-popup {
  padding: 20px;
  text-align: center;
}

.success-logo {
  width: 70px;
  height: 70px;
  margin: 0 auto 16px;
}

.success-message {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.order-info {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.service-name {
  font-size: 16px;
  font-weight: 600;
  color: #1976D2;
  margin-top: 8px;
}

.next-steps {
  text-align: left;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.next-steps h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #333;
}

.next-steps ol {
  margin: 0;
  padding-left: 16px;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

.next-steps li {
  margin-bottom: 4px;
}
</style>
